export const TAX_WHLD_METHODS = Object.freeze({
  KKREN: 'KKREN',
  HCTCOD: 'HCTCOD',
})

export const DEFAULT_TAX_WHLD_METHOD = TAX_WHLD_METHODS.KKREN

export const TAX_WHLD_METHOD_NOTE = '稅金代收服務費於稅金產生後隨稅金一併收取。'

export const TAX_WHLD_METHOD_OPTIONS = Object.freeze([
  Object.freeze({
    value: TAX_WHLD_METHODS.HCTCOD,
    title: '新竹物流代收',
    feeText: '服務費 30 元',
    label: '新竹物流代收／服務費 30 元',
  }),
  Object.freeze({
    value: TAX_WHLD_METHODS.KKREN,
    title: '線上代收',
    feeText: '服務費 25 元',
    label: '線上代收／服務費 25 元',
  }),
])

const ONLINE_ONLY_TAX_WHLD_METHOD_OPTIONS = Object.freeze(
  TAX_WHLD_METHOD_OPTIONS.filter(option => option.value === TAX_WHLD_METHODS.KKREN)
)

export function isTaxWhldMethodOnlineOnly ({
  srLabel = '',
  jyoCarrier = '',
  deliveryMode = '',
} = {}) {
  return srLabel === 'HZKZQ' ||
    deliveryMode === 'cvs' ||
    Boolean(jyoCarrier && jyoCarrier !== 'hct')
}

export function isTaxWhldMethodFullTax ({
  jyoShpMethod = '',
  useFeeType = '',
  isAllIncTax = false,
  allItemInclFreight = 'N',
} = {}) {
  if (jyoShpMethod === '81' || jyoShpMethod === '91') return false
  return isAllIncTax || allItemInclFreight === 'Y' || useFeeType === 'tax'
}

export function getAvailableTaxWhldMethodOptions (context) {
  return isTaxWhldMethodOnlineOnly(context)
    ? ONLINE_ONLY_TAX_WHLD_METHOD_OPTIONS
    : TAX_WHLD_METHOD_OPTIONS
}

export function getTaxWhldMethodOption (value) {
  return TAX_WHLD_METHOD_OPTIONS.find(option => option.value === value) || null
}

export function normalizeTaxWhldMethod (value, context) {
  if (context?.isFullTax || isTaxWhldMethodOnlineOnly(context)) return DEFAULT_TAX_WHLD_METHOD
  return getTaxWhldMethodOption(value)?.value || DEFAULT_TAX_WHLD_METHOD
}

export function finalizeTaxWhldMethodParams (params, includeTaxWhldMethod, context) {
  const extraFees = params.jyoExtraFees || {}
  if (includeTaxWhldMethod) {
    params.jyoExtraFees = {
      ...extraFees,
      taxWhldMethod: normalizeTaxWhldMethod(extraFees.taxWhldMethod, context),
    }
    return params
  }

  if (!Object.prototype.hasOwnProperty.call(extraFees, 'taxWhldMethod')) return params
  const nextExtraFees = { ...extraFees }
  delete nextExtraFees.taxWhldMethod
  if (Object.keys(nextExtraFees).length) params.jyoExtraFees = nextExtraFees
  else delete params.jyoExtraFees
  return params
}
